import {all, takeEvery, select, call, put } from '@redux-saga/core/effects';
import actionTypes from '../actions/actionTypes';
import { httpClient, paymentMethodsBaseUrl } from '../../http-client/http-client';
import { paymentMethodsActions } from '../actions/paymentMethods/paymentMethods';

const accessTokenSelector = (state) => state.oidc.user.access_token;

function* fetchList(action) {
  const accessToken = yield select(accessTokenSelector);
  const url = `${paymentMethodsBaseUrl}/list`;

  try {
    const data = yield call(httpClient.get, url, accessToken);
    yield put(paymentMethodsActions.fetchOk(data.List));
  }
  catch(error) {
    yield put(paymentMethodsActions.fetchError(error));
  }
}

function* remove(action) {
  const accessToken = yield select(accessTokenSelector);
  const pmId = action.id;
  const url = `${paymentMethodsBaseUrl}/remove`;
  const model = {
    id: pmId
  };

  try {
    yield put(paymentMethodsActions.setProcessing(pmId, true));
    const data = yield call(httpClient.post, url, accessToken, model);
    yield put(paymentMethodsActions.removeOk(pmId))
  }
  catch(error) {
    yield put(paymentMethodsActions.setProcessing(pmId, false));
    // dispatch notification of failure
  }
}

function* setAsPrimary(action) {
  const accessToken = yield select(accessTokenSelector);
  const pmId = action.id;
  const url = `${paymentMethodsBaseUrl}/setAsPrimary`;
  const model = {
    id: pmId
  };

  try {
    yield put(paymentMethodsActions.setProcessing(pmId, true));
    const data = yield call(httpClient.post, url, accessToken, model);
    yield put(paymentMethodsActions.setAsPrimaryOk(pmId))
    yield put(paymentMethodsActions.setProcessing(pmId, false));
  }
  catch(error) {
    yield put(paymentMethodsActions.setProcessing(pmId, false));
    // dispatch notification of failure
  }
}

export function* watchPaymentMethods() {
  yield all([
    takeEvery(actionTypes.paymentMethods.FETCH, fetchList),
    takeEvery(actionTypes.paymentMethods.REMOVE, remove),
    takeEvery(actionTypes.paymentMethods.SET_AS_PRIMARY, setAsPrimary),
  ]);
}